export default "__VITE_ASSET__DMQfYkka__"